import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { clearUser } from "@store/slices/userSlice";
import { clearAuthData } from "@utils/auth";
import { BROWSER_ROUTES } from "@constants/browser.routes";
import { PORTAL_SOURCE_WP_STORAGE_KEY } from "@constants/portalSourceWp.constants";
import { resetUnauthorizedFlag } from "@config/axios/axios.config";

export const useLogout = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const [showLogoutModal, setShowLogoutModal] = useState(false);

	const handleLogoutClick = () => {
		setShowLogoutModal(true);
	};

	const handleLogoutConfirm = () => {
		resetUnauthorizedFlag();
		dispatch(clearUser());
		clearAuthData();
		sessionStorage.removeItem(PORTAL_SOURCE_WP_STORAGE_KEY);
		/** Drop role-scoped API caches (event types, calendars, etc.) before the next login. */
		queryClient.clear();
		document.title = "Admin Portal";
		navigate(BROWSER_ROUTES.DASHBOARD);
		setShowLogoutModal(false);
	};

	const handleLogoutCancel = () => {
		setShowLogoutModal(false);
	};

	return {
		handleLogout: handleLogoutClick,
		handleLogoutConfirm,
		handleLogoutCancel,
		showLogoutModal,
	};
};
